import { isAuthenticated } from 'auth/authHandler';
import React, { useEffect } from 'react';
import Loading from 'screens/Loading';

export interface SecureProps {
  children: React.ReactNode;
}

const Secured: React.FC<SecureProps> = ({ children }) => {
  const [isAuthed, setIsAuthed] = React.useState(false);
  useEffect(() => {
    const checkAuth = async () => {
      const authenticated = await isAuthenticated();
      setIsAuthed(authenticated);
    };
    checkAuth();
  }, []);

  return <>{isAuthed ? children : <Loading />}</>;
};

export default Secured;
